export const TOGGLE_FULLSCREEN_FILTER = 'TOGGLE_FULLSCREEN_FILTER';

export type FullscreenFilter = {
    isActive: boolean;
};

type ToggleFullscreenFilterAction = {
    type: string;
};

const initialState: FullscreenFilter = {
    isActive: false,
};

export const toggleFullscreenFilter = (): ToggleFullscreenFilterAction => ({
    type: TOGGLE_FULLSCREEN_FILTER,
});

export default (
    state: FullscreenFilter = initialState,
    action: ToggleFullscreenFilterAction
): FullscreenFilter =>
    action.type === TOGGLE_FULLSCREEN_FILTER ? { ...state, isActive: !state.isActive } : state;
